<script>
import vDatePicker from "v-calendar/lib/components/date-picker.umd";
import HolidayWarning from "@/components/_Shared/Warnings/Holiday";

import paymentValidators from "@/utils/validators/payments";
import holidayHelper from "@/utils/helpers/holiday";

import { ptBR } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    vDatePicker,
    HolidayWarning
  },

  props: {
    value: {
      type: [Date, String],
      required: false
    }
  },

  methods: {
    fromDate() {
      let date = new Date();
      return date.setDate(date.getDate() + 1);
    },

    toDate() {
      let date = new Date();
      return date.setMonth(date.getMonth() + 4);
    }
  },

  data() {
    return {
      i18n: {
        input: "DD/MM/YYYY",
        title: "MMMM"
      },
      attributes: {
        class:
          "w-full shadow appearance-none border rounded py-2 px-3 text-gray-700 hover:border-blue-5 text-center",
        placeholder: "Selecione um dia",
        readonly: true
      }
    };
  }
};
</script>

<template>
    <div>
        <v-date-picker
        color="purple"
        :min-date="fromDate()"
        :max-date="toDate()"
        :value="value"
        @input="$emit('input', $event)"
        :input-props='attributes'
        :masks="i18n"
        :popover="{ placement: $screens({ default: 'bottom'}) }"
        />
        <br>

      <holiday-warning v-if="value" :day="value" style="max-width: 450px; text-align: center;" />
    </div>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/DatePicker/DatePicker.vue